<template>
  <modal
    :name="name"
    :width="width"
    :height="height"
    @closed="onClosedModal"
    @opened="openedModal"
  >
    <div class="isis-modal-content">
      <div class="isis-modal-header" v-if="!hideHeader">
        <h3 class="title">{{ $t(title) || "Common modal" }}</h3>
        <button class="close-btn" @click.prevent="$modal.hide(name)">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <md-content
        class="isis-modal-body overflow-y-auto md-scrollbar"
        ref="modalBody"
      >
        <slot name="modal-body">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores
            ipsam voluptates eaque? Quibusdam, culpa quasi!
          </p>
        </slot>
      </md-content>

      <div class="isis-modal-footer" v-if="!hideFooter">
        <template v-if="!!primaryAction">
          <md-button
            class="md-success"
            :class="primaryAction.class"
            @click.prevent="primaryAction.action"
            :disabled="primaryAction.disabled || disabledActions"
          >
            {{ $t(primaryAction.title) }}
          </md-button>
        </template>

        <template v-if="!!secondaryActions">
          <md-button
            v-for="(btnAction, idx) in secondaryActions"
            :key="`action-button-${idx}`"
            class="mr-2"
            @click.prevent="btnAction.action"
            :disabled="btnAction.disabled || disabledActions"
          >
            {{ $t(btnAction.title) }}
          </md-button>
        </template>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "common-modal",
  props: [
    "name",
    "title",
    "primaryAction",
    "secondaryActions",
    "height",
    "onClosed",
    "disabledActions",
    "width",
    "hideHeader",
    "hideFooter"
  ],
  data() {
    return {
      bodyScrollClass: "",
      bodyOverflowY: ""
    };
  },
  methods: {
    onClosedModal() {
      this.onClosed && this.onClosed();
      this.revertBodyScrollBar();
    },

    openedModal() {
      this.hideBodyScrollBar();
    },

    hideBodyScrollBar() {
      const hasScrollBar = document.body.classList.contains(
        "perfect-scrollbar-on"
      );

      if (hasScrollBar) {
        this.bodyScrollClass = "perfect-scrollbar-on";
        this.bodyOverflowY = document.body.style.overflowY;

        document.body.classList.remove("perfect-scrollbar-on");
        document.body.style.overflowY = "hidden";
      }
    },

    revertBodyScrollBar() {
      if (this.bodyScrollClass) {
        document.body.classList.add(this.bodyScrollClass);
      }

      if (this.bodyOverflowY) {
        document.body.style.overflowY = this.bodyOverflowY;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$border-color: #c3c3c3;
$black-color: #3c4858;
$gray-light: #999999;
$header-height: 65px;
$footer-height: 82px;

.isis-modal-content {
  max-height: 80vh;

  & > * {
    padding: 15px;
  }

  .isis-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    border-bottom: 1px solid $border-color;

    .title {
      padding: 0;
      margin: 0;

      font-size: 16px;
      font-weight: 600;
    }

    button.close-btn {
      padding: 5px 8px;
      border: none;
      background-color: transparent;
      transition: 0.15s;
      cursor: pointer;
      border-radius: 3px;

      &:focus {
        outline: none;
        border: none;
      }

      &:hover {
        background-color: rgba($gray-light, 0.4);
      }

      i {
        font-size: 16px;
        color: $black-color;
      }
    }
  }

  .isis-modal-body {
    max-height: calc(80vh - #{$footer-height} - #{$header-height});
  }

  .isis-modal-footer {
    // position: absolute;
    // bottom: 0;
    // z-index: 2;

    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    width: 100%;

    border-top: 1px solid $border-color;
  }
}
</style>
